import { type TSocketEvent } from '@/types/ISocketEvent';
import { isCallEvent } from './isCallEvent';
import { isCallHistoryEvent } from './isCallHistoryEvent';
import { isSocketOrderEvent } from './isSocketOrderEvent';

/**
 * Парсит сырую строку `data:` из SSE-потока Mercure и размечает её по
 * источнику. Все топики приходят в одно соединение, а имя топика в кадре
 * Mercure не передаётся — маршрутизируем только по форме payload.
 *
 * Guard'ы взаимоисключающи **по построению**, а не по порядку вызовов: заказ
 * опознаётся по `event === 'order_post_persist'`, живой звонок требует
 * `status === null`, историческое событие — маркер топика либо известный
 * статус. Одно и то же событие не может подойти под два guard'а, поэтому
 * порядок ниже влияет только на читаемость.
 *
 * @param raw - строка из поля `data:` события Mercure
 * @returns размеченное событие или `null`, если форма неизвестна
 */
export const parseSocketEvent = (raw: string): TSocketEvent | null => {
  let parsed: unknown;

  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }

  if (isSocketOrderEvent(parsed)) {
    return { kind: 'order', event: parsed };
  }

  if (isCallEvent(parsed)) {
    return { kind: 'call', event: parsed };
  }

  if (isCallHistoryEvent(parsed)) {
    return { kind: 'callHistory', event: parsed };
  }

  return null;
};
